// extracted by mini-css-extract-plugin
export var cardIcon = "_4n-4";
export var checkboxCard = "_4n-0";
export var checkboxCardSelected = "_4n-1";
export var disabled = "_4n-2";
export var outerBorder = "_4n-3";
export var spacerMedium = "_4n-7";
export var spacerSmall = "_4n-6";
export var spacerXsmall = "_4n-5";